import * as types from './mutation-types'
import Vue from 'vue'
import { IAdminMissionState } from './state'
import deepEqual from 'deep-equal'  
import { MutationTree } from 'vuex/types'
import { AloDbMission, IAloDbMissionConstParam } from '@/models/alodb/AloDbMission';
import { WobAdminChanged } from '@/models/wob/WobAdminChanged';
import { AloDbRoleMapping } from '@/models/alodb/AloDbRoleMapping';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IAdminMissionState> = {
     
    //Gestion des recherches de missions
    [types.ADMINMISSION_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.adminMissionLoading = true
    },
    [types.ADMINMISSION_SUCCESS]: (state, missions:Array<AloDbMission>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.adminMissions = missions          
        state.adminMissionLoading = false      
    },
    [types.ADMINMISSION_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.adminMissions = []
        state.adminMissionLoading = false
    },
    [types.ADMINMISSION_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${itemId}`}).toString()
        state.adminMissionLoading = true
    },
    [types.ADMINMISSION_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.adminMissionLoading = false
    },
    [types.ADMINMISSION_SELECT_DETAIL_SUCCESS]: (state,mission:AloDbMission) => {        
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${mission.MIS_ID}`}).toString()          
        //1, on met à jour de m'mission dans la liste des missions
        const index = state.adminMissions.findIndex(m => m.MIS_ID == mission.MIS_ID)
        state.adminMissions.splice(index == -1 ? state.adminMissions.length : index, index == -1 ? 0 : 1, mission)
        state.adminMissionLoading = false
    },
    [types.ADMINMISSION_SELECT_DETAIL]: (state,mission:AloDbMission) => {                
        state.originalAdmAdminMission = mission
        state.modifiedAdmAdminMission = new AloDbMission(mission as IAloDbMissionConstParam)
    },
    [types.ADMINMISSION_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${libelle}`}).toString()
        state.adminMissionLoading = true
    },
    [types.ADMINMISSION_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.adminMissionLoading = false
    },
    [types.ADMINMISSION_DELETE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.DeleteItem',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${libelle}`}).toString()
        state.adminMissionLoading = true
    },
    [types.ADMINMISSION_DELETE_SUCCESS]: (state,misId:number) => {
        state.status = i18n.t('Admin.DeleteItemOk',{item:`${i18n.t('Admin.AdminMission.Title').toString()} ${misId}`}).toString()
        const index = state.adminMissions.findIndex(m => m.MIS_ID == misId)
        state.adminMissions.splice(index == -1 ? state.adminMissions.length : index, index == -1 ? 0 : 1)
        state.adminMissionLoading = false
    },
    [types.ADMINMISSION_DELETE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorDelete',{item:i18n.t('Admin.AdminMission.Title').toString()}).toString()
        state.adminMissionLoading = false
    },
    [types.ADMINMISSION_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmAdminMission = {...state.modifiedAdmAdminMission,...newProperties}
    },
    [types.ADMINMISSION_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    },
    [types.ADMINMISSION_EXTERNAL_UPDATE]: (state, wob: WobAdminChanged<AloDbMission>) => {        
        //on met à jour ou ajoute l'objet dans la liste
        if(wob.actionType == "Added" || wob.actionType == "Modified") {
            //1, on met à jour de m'mission dans la liste des missions
            const index = state.adminMissions.findIndex(m => m.MIS_ID == wob.newAloDbItem.MIS_ID)
            state.adminMissions.splice(index == -1 ? state.adminMissions.length : index, index == -1 ? 0 : 1, wob.newAloDbItem)        
            if(state.originalAdmAdminMission.MIS_ID == wob.newAloDbItem.MIS_ID) {            
                if(deepEqual(state.originalAdmAdminMission,state.modifiedAdmAdminMission)){
                    state.modifiedAdmAdminMission = new AloDbMission(wob.newAloDbItem as IAloDbMissionConstParam)
                }                        
                state.originalAdmAdminMission = wob.newAloDbItem                        
            }
        }
        //on supprime l'objet de la liste si existant
        else if(wob.actionType == "Deleted") {
            const index = state.adminMissions.findIndex(m => m.MIS_ID == wob.oldAloDbItem.MIS_ID)
            state.adminMissions.splice(index == -1 ? state.adminMissions.length : index, index == -1 ? 0 : 1)        
        }
    },
    [types.ADMINMISSION_ROLEMAPPING_REQUEST]: (state, itemId:number) => {
        state.status = `loading role mapping for mission ${itemId}`
        state.adminMissionRoleMappingLoading = true
    },
    [types.ADMINMISSION_ROLEMAPPING_SUCCESS]: (state, rolesMapping:Array<AloDbRoleMapping>) => {
        state.status = 'success loading role mapping for mission '
        state.modifiedAdmAdminMissionRolesMapping = rolesMapping   
        state.adminMissionRoleMappingLoading = false             
    },
    [types.ADMINMISSION_ROLEMAPPING_ERROR]: state => {
        state.status = 'error loading role mapping for mission '
        state.modifiedAdmAdminMissionRolesMapping = []
        state.adminMissionRoleMappingLoading = false
    },
    [types.ADMINMISSION_ADD_ROLEMAPPING_SUCCESS]: (state, roleMapping:AloDbRoleMapping) => {
        //on s'assure que l'utilisateur en cours est toujours le bon
        if(state.originalAdmAdminMission.MIS_ID == roleMapping.MAP_ID && roleMapping.MAP_OBJECT == "mission") {
            const index = state.modifiedAdmAdminMissionRolesMapping.findIndex(m => m.USR_ID == roleMapping.USR_ID && m.MAP_OBJECT == roleMapping.MAP_OBJECT && m.MAP_ID == roleMapping.MAP_ID  && m.ROL_KEY == roleMapping.ROL_KEY)
            //on s'assure que le mapping n'est pas deja présent
            if(index == -1) state.modifiedAdmAdminMissionRolesMapping.push(roleMapping)
        }        
    },
    [types.ADMINMISSION_REMOVE_ROLEMAPPING_SUCCESS]: (state, roleMapping:AloDbRoleMapping) => {
        //on s'assure que l'utilisateur en cours est toujours le bon
        if(state.originalAdmAdminMission.MIS_ID == roleMapping.MAP_ID && roleMapping.MAP_OBJECT == "mission") {
            const index = state.modifiedAdmAdminMissionRolesMapping.findIndex(m => m.USR_ID == roleMapping.USR_ID && m.MAP_OBJECT == roleMapping.MAP_OBJECT && m.MAP_ID == roleMapping.MAP_ID  && m.ROL_KEY == roleMapping.ROL_KEY)            
            state.modifiedAdmAdminMissionRolesMapping.splice(index == -1 ? state.modifiedAdmAdminMissionRolesMapping.length : index, index == -1 ? 0 : 1)            
        }        
    }
}


export default mutations
